import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { API } from '../App';
import './ConsultationPage.css';

const ZONES_FRONT = [
  { id: 'tete',            x: 22, y: 1,  w: 10, h: 10 },
  { id: 'cou',              x: 25, y: 11, w: 4,  h: 4  },
  { id: 'epaule-g',         x: 15, y: 14, w: 10, h: 6  },
  { id: 'epaule-d',         x: 30, y: 14, w: 10, h: 6  },
  { id: 'thorax',           x: 20, y: 15, w: 14, h: 12 },
  { id: 'bras-g',           x: 10, y: 18, w: 7,  h: 12 },
  { id: 'bras-d',           x: 37, y: 18, w: 7,  h: 12 },
  { id: 'avant-bras-g',     x: 7,  y: 30, w: 6,  h: 10 },
  { id: 'avant-bras-d',     x: 41, y: 30, w: 6,  h: 10 },
  { id: 'main-g',           x: 5,  y: 40, w: 6,  h: 8  },
  { id: 'main-d',           x: 43, y: 40, w: 6,  h: 8  },
  { id: 'abdomen',          x: 20, y: 27, w: 14, h: 10 },
  { id: 'bassin',           x: 19, y: 37, w: 16, h: 8  },
  { id: 'cuisse-g',         x: 19, y: 45, w: 7,  h: 15 },
  { id: 'cuisse-d',         x: 28, y: 45, w: 7,  h: 15 },
  { id: 'genou-g',          x: 19, y: 60, w: 7,  h: 6  },
  { id: 'genou-d',          x: 28, y: 60, w: 7,  h: 6  },
  { id: 'jambe-g',          x: 19, y: 66, w: 6,  h: 14 },
  { id: 'jambe-d',          x: 28, y: 66, w: 6,  h: 14 },
  { id: 'pied-g',           x: 18, y: 80, w: 7,  h: 8  },
  { id: 'pied-d',           x: 27, y: 80, w: 7,  h: 8  },
];

const ZONES_BACK = [
  { id: 'nuque',              x: 72, y: 1,  w: 10, h: 10 },
  { id: 'epaule-g-dos',       x: 65, y: 14, w: 10, h: 6 },
  { id: 'epaule-d-dos',       x: 80, y: 14, w: 10, h: 6 },
  { id: 'haut-dos',           x: 70, y: 15, w: 14, h: 12 },
  { id: 'bras-g-dos',         x: 60, y: 18, w: 7,  h: 12 },
  { id: 'bras-d-dos',         x: 87, y: 18, w: 7,  h: 12 },
  { id: 'avant-bras-g-dos',   x: 57, y: 30, w: 6, h: 10 },
  { id: 'avant-bras-d-dos',   x: 91, y: 30, w: 6, h: 10 },
  { id: 'bas-dos',            x: 70, y: 27, w: 14, h: 10 },
  { id: 'lombaires',          x: 70, y: 37, w: 14, h: 8  },
  { id: 'fessiers',           x: 69, y: 45, w: 16, h: 10 },
  { id: 'cuisse-g-dos',       x: 69, y: 55, w: 7, h: 15 },
  { id: 'cuisse-d-dos',       x: 78, y: 55, w: 7, h: 15 },
  { id: 'mollet-g',           x: 69, y: 66, w: 6,  h: 14 },
  { id: 'mollet-d',           x: 78, y: 66, w: 6,  h: 14 },
  { id: 'talon-g',            x: 68, y: 80, w: 7,  h: 8  },
  { id: 'talon-d',            x: 77, y: 80, w: 7,  h: 8  },
];

// Zones pieds — image 2×2 : plantaire haut, dorsale bas ; gauche à gauche, droit à droite
const ZONES_FEET = [
  // Plantaire gauche (quadrant haut-gauche)
  { id: 'orteils-g-pl',    x: 16, y: 3,  w: 22, h: 8  },
  { id: 'metatarses-g-pl', x: 16, y: 11, w: 22, h: 9  },
  { id: 'voute-g',         x: 18, y: 20, w: 18, h: 13 },
  { id: 'talon-g-pl',      x: 17, y: 33, w: 20, h: 12 },
  // Plantaire droit (quadrant haut-droit)
  { id: 'orteils-d-pl',    x: 62, y: 3,  w: 22, h: 8  },
  { id: 'metatarses-d-pl', x: 62, y: 11, w: 22, h: 9  },
  { id: 'voute-d',         x: 63, y: 20, w: 18, h: 13 },
  { id: 'talon-d-pl',      x: 62, y: 33, w: 20, h: 12 },
  // Dorsale gauche (quadrant bas-gauche)
  { id: 'orteils-g-do',    x: 16, y: 53, w: 22, h: 8  },
  { id: 'metatarses-g-do', x: 16, y: 61, w: 22, h: 9  },
  { id: 'dos-pied-g',      x: 18, y: 70, w: 18, h: 13 },
  { id: 'cheville-g',      x: 17, y: 83, w: 20, h: 10 },
  // Dorsale droite (quadrant bas-droit)
  { id: 'orteils-d-do',    x: 62, y: 53, w: 22, h: 8  },
  { id: 'metatarses-d-do', x: 62, y: 61, w: 22, h: 9  },
  { id: 'dos-pied-d',      x: 63, y: 70, w: 18, h: 13 },
  { id: 'cheville-d',      x: 62, y: 83, w: 20, h: 10 },
];

const ALL_ZONES = [...ZONES_FRONT, ...ZONES_BACK, ...ZONES_FEET];

export default function ConsultationPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [sexe, setSexe] = useState('');
  const [painLevel, setPainLevel] = useState(0);
  const [handicap, setHandicap] = useState(0);
  const [selectedZones, setSelectedZones] = useState(new Set());
  const [radios, setRadios] = useState([]);
  const [irm, setIrm] = useState([]);
  const [notes, setNotes] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${API}/api/patients/${id}`)
      .then(r => r.json())
      .then(d => setSexe(d.sexe || ''))
      .catch(() => {});
  }, [id]);

  const bodyMapSrc = sexe === 'F' ? '/body-map-female.png' : '/body-map.png';

  // Traduction d'une zone à partir de son id
  const zoneLabel = (zoneId) => t(`consultation.zones.${zoneId}`);

  const toggleZone = (zoneId) => {
    setSelectedZones(prev => {
      const next = new Set(prev);
      if (next.has(zoneId)) next.delete(zoneId);
      else next.add(zoneId);
      return next;
    });
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    setError('');
    try {
      const fd = new FormData();
      fd.append('pain_level', painLevel);
      fd.append('handicap', handicap);
      fd.append('pain_zones', JSON.stringify([...selectedZones].map(zoneId => zoneLabel(zoneId))));
      fd.append('notes', notes);

      const res = await fetch(`${API}/api/patients/${id}/consultation`, { method: 'POST', body: fd });
      if (!res.ok) throw new Error(`Erreur ${res.status}`);

      for (const file of radios) {
        const pfd = new FormData();
        pfd.append('file', file);
        pfd.append('type', 'radio');
        const dres = await fetch(`${API}/api/patients/${id}/document`, { method: 'POST', body: pfd });
        if (!dres.ok) throw new Error(`Erreur ${dres.status} lors de l'envoi de la radiographie "${file.name}"`);
      }
      for (const file of irm) {
        const pfd = new FormData();
        pfd.append('file', file);
        pfd.append('type', 'irm');
        const dres = await fetch(`${API}/api/patients/${id}/document`, { method: 'POST', body: pfd });
        if (!dres.ok) throw new Error(`Erreur ${dres.status} lors de l'envoi de l'IRM "${file.name}"`);
      }

      navigate(`/analysis/${id}`);
    } catch (e) {
      setError(e.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="consultation-page">
      <header className="consult-header">
        <button className="back-btn" onClick={() => navigate('/')}>{t('common.back')}</button>
        <p className="consult-eyebrow">{t('consultation.eyebrow')}</p>
        <h1 className="consult-title">{t('consultation.title')}</h1>
      </header>

      <div className="consult-body">

        <section className="consult-section">
          <div className="section-label">{t('consultation.pain_level')}</div>
          <div className="slider-row">
            <label>{t('consultation.pain_level')} : <strong>{painLevel}/10</strong></label>
            <input type="range" min="0" max="10" step="1" value={painLevel}
              onChange={e => setPainLevel(Number(e.target.value))} />
            <div className="scale-hints"><span>{t('consultation.pain_none')}</span><span>{t('consultation.pain_max')}</span></div>
          </div>
          <div className="slider-row">
            <label>{t('consultation.handicap')} : <strong>{handicap}/10</strong></label>
            <input type="range" min="0" max="10" step="1" value={handicap}
              onChange={e => setHandicap(Number(e.target.value))} />
            <div className="scale-hints"><span>{t('consultation.handicap_none')}</span><span>{t('consultation.handicap_max')}</span></div>
          </div>
        </section>

        <section className="consult-section">
          <div className="section-label">{t('consultation.pain_location')}</div>
          <div className="body-map-wrap">
            <img src={bodyMapSrc} alt={t('consultation.body_alt')} className="body-map-img" draggable={false} />
            {[...ZONES_FRONT, ...ZONES_BACK].map(zone => (
              <div
                key={zone.id}
                className={`body-zone ${selectedZones.has(zone.id) ? 'active' : ''}`}
                style={{ left: `${zone.x}%`, top: `${zone.y}%`, width: `${zone.w}%`, height: `${zone.h}%` }}
                onClick={() => toggleZone(zone.id)}
                title={zoneLabel(zone.id)}
              />
            ))}
          </div>
        </section>

        <section className="consult-section">
          <div className="section-label">{t('consultation.feet_location')}</div>
          <div className="feet-map-labels">
            <span>{t('consultation.plantar_left')}</span>
            <span>{t('consultation.plantar_right')}</span>
            <span>{t('consultation.dorsal_left')}</span>
            <span>{t('consultation.dorsal_right')}</span>
          </div>
          <div className="body-map-wrap">
            <img src="/feet_views.jpg" alt={t('consultation.feet_alt')} className="body-map-img" draggable={false} />
            {ZONES_FEET.map(zone => (
              <div
                key={zone.id}
                className={`body-zone ${selectedZones.has(zone.id) ? 'active' : ''}`}
                style={{ left: `${zone.x}%`, top: `${zone.y}%`, width: `${zone.w}%`, height: `${zone.h}%` }}
                onClick={() => toggleZone(zone.id)}
                title={zoneLabel(zone.id)}
              />
            ))}
          </div>
        </section>

        {selectedZones.size > 0 && (
          <section className="consult-section">
            <div className="pain-tags">
              {[...selectedZones].map(zoneId => (
                <span key={zoneId} className="pain-tag">
                  {zoneLabel(zoneId)}
                  <button onClick={() => toggleZone(zoneId)}>×</button>
                </span>
              ))}
            </div>
          </section>
        )}

        <section className="consult-section">
          <div className="section-label">{t('consultation.imaging')}</div>
          <div className="fields-row">
            <div className="field">
              <label>{t('consultation.radios')}</label>
              <label className="file-label">
                <input type="file" accept="image/*,.pdf" multiple
                  onChange={e => setRadios(Array.from(e.target.files))} />
                <span className="file-cta">
                  {radios.length > 0 ? t('consultation.files_selected', { count: radios.length }) : t('consultation.load_radios')}
                </span>
              </label>
            </div>
            <div className="field">
              <label>{t('consultation.irm')}</label>
              <label className="file-label">
                <input type="file" accept="image/*,.pdf" multiple
                  onChange={e => setIrm(Array.from(e.target.files))} />
                <span className="file-cta">
                  {irm.length > 0 ? t('consultation.files_selected', { count: irm.length }) : t('consultation.load_irm')}
                </span>
              </label>
            </div>
          </div>
        </section>

        <section className="consult-section">
          <div className="section-label">{t('consultation.notes')}</div>
          <textarea className="notes-area" rows={3} value={notes}
            onChange={e => setNotes(e.target.value)}
            placeholder={t('consultation.notes_placeholder')} />
        </section>

        {error && <div className="consult-error">{error}</div>}

        <div className="consult-actions">
          <button className="btn-ghost" onClick={() => navigate('/')}>{t('consultation.cancel')}</button>
          <button className="btn-primary" onClick={handleSubmit} disabled={submitting}>
            {submitting ? t('common.loading') : t('consultation.continue')}
          </button>
        </div>

      </div>
    </div>
  );
}